import { Component } from '@angular/core';
import { DevMail } from '../../netgen/DevMail';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { Objects } from 'src/modules/utils/shared/objects';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';

@Component({
  selector: 'app-dev-main',
  standalone: false,
  templateUrl: './dev-main.component.html',
  styleUrl: './dev-main.component.scss'
})
export class DevMainComponent extends ComponentView {

    data: DevMail[] = [];
    table: TableData;

    async initParams(): Promise<boolean> {
        await this.update();
        return true;
    }

    async update(): Promise<void> {
        this.data = await RestEndpoint.main().run("api/dsm/mail").list(DevMail);
        
        let groups: DevMail[] = [];
        for (let mail of this.data) {
            let group = groups.find(g => g.customer == mail.customer && g.product == mail.product && g.subProduct == mail.subProduct);
            if (group == null) {
                group = Objects.fromPlain(DevMail, {
                    customer: mail.customer,
                    product: mail.product,
                    subProduct: mail.subProduct
                });
                groups.push(group);
            }
            group.count++;
            group.score += mail.getScore();
        }
        
        this.table = new TableData([
            new TableColumn("score", "Score", TableCellType.decimal, 5, {
                numDecimalDigits: 2
            }),
            new TableColumn("count", "Anzahl", TableCellType.int, 5),
            new TableColumn("customer", "Kunde", TableCellType.string, 20),
            new TableColumn("product", "Produkt", TableCellType.string, 20),
            new TableColumn("subProduct", "Unterprodukt", TableCellType.string, 20)
        ], groups.map(group => new TableRow(group.customer + "|" + group.product + "|" + group.subProduct, group, group)), [new TableSortColumn("score", false), new TableSortColumn("count", false)])
    }
}